export default {
    title: 'ตัวอักษรเมล็ดพันธุ์',

    level: {
        format: 'เลเวล {level}',
        nextLevel: 'เลเวลถัดไป',
        currentLevel: 'เลเวลปัจจุบัน',
    },

    session: {
        count: '{count} ครั้ง',
        exam: 'แบบทดสอบย่อย',
        examScore: '{score} คะแนน',
        study: 'การเรียน',
        completed: 'เสร็จสิ้น',
        locked: 'ล็อก',
        inProgress: 'กำลังทำ',
    },

    navigation: {
        toWaitingRoom: 'ไปที่ห้องรอ',
        toStudy: 'เรียน',
        toExam: 'ทำข้อสอบ',
        continue: 'ทำต่อ',
        stop: 'หยุด',
    },

    study: {
        start: 'เริ่ม',
        continue: 'ทำต่อ',
        complete: 'เสร็จสิ้น',
        stop: 'หยุด',
        stopConfirm: 'ต้องการหยุดการเรียนจริงหรือไม่?',
        example: 'ประโยคตัวอย่าง',
        meaning: 'ความหมาย',
        sound: 'เสียง',
        listen: 'ฟังเสียง',
    },

    exam: {
        start: 'เริ่ม',
        grade: 'ตรวจให้คะแนน',
        result: 'ดูผลลัพธ์',
        questions: {
            intro: 'เริ่มทำโจทย์',
            upper: 'โจทย์ตัวอักษรบน',
            lower: 'โจทย์ตัวอักษรล่าง',
        },
    },

    modal: {
        studyComplete: {
            title: 'เรียนเสร็จ',
            message: 'ยินดีด้วย! เรียนเสร็จแล้ว',
        },
        examComplete: {
            title: 'สอบเสร็จ',
            message: 'สอบเสร็จแล้ว',
        },
        stopConfirm: {
            title: 'หยุดการเรียน',
            message: 'ต้องการหยุดการเรียนจริงหรือไม่?<br/>ความคืบหน้าอาจไม่ถูกบันทึก',
        },
    },

    errors: {
        audioPlay: 'เกิดปัญหาขณะเล่นเสียง',
        loadData: 'เกิดข้อผิดพลาดขณะโหลดข้อมูล',
    },
};
